import subContext from './sub-context.js'
import moduleShow from './module-show.js'

/**
 * Build a reference store for simple object references (used in show stores).
 *
 * @param {ModuleBuilderContext} context
 * @param {object} properties
 *
 * @return object
 */
export default function buildReferences (context, properties) {
  const {$name, $namespace, $parentNamespace} = context;
  const references = {}
  const referenceNames = []
  Object.keys(properties).map((propName) => {
    if (properties[propName].reference) {
      references[propName] = moduleShow(subContext(context, propName, {resource: context.parsed[properties[propName].reference]}), false)
      referenceNames.push(propName)
    }
  });

  if (referenceNames.length === 0) {
    return undefined
  }

  return {
    namespaced: true,
    state: {
      $name,
      $namespace,
      $parentNamespace
    },
    modules: {
      ...references
    },
    actions: {
      /**
       * @param {function} commit
       * @param {function} dispatch
       * @param {object}   data     The data of the parenting resource.
       */
      loadFor: ({ commit, dispatch }, data) => {
        referenceNames.map((propName) => {
          if (data[propName]) {
            dispatch(propName + '/retrieve', data[propName])
          }
        })
      },
      reset: ({ dispatch }) => {
        referenceNames.map((propName) => {
          dispatch(propName + '/reset')
        })
      }
    }
  }
}
